import React from 'react';

import Switch from '../switch';

import { InputSwitchBaseProps } from '../../types/TInputSwitch';

import { StyledInputSwitch } from './input-switch-styles';

const InputSwitch = ({
  label,
  checked,
  changeChecked,
  name,
  alignRow,
  fieldRefSwitch,
  className,
  disabled = false,
  secondarySwitch,
}: InputSwitchBaseProps) => (
  <StyledInputSwitch
    alignRow={alignRow}
    className={className}
  >
    {label && <label htmlFor={name}>{label}</label>}

    <Switch
      fieldRefSwitch={fieldRefSwitch}
      name={name}
      id={name}
      disabled={disabled}
      checked={checked}
      changeChecked={changeChecked}
      secondarySwitch={secondarySwitch}
    />
  </StyledInputSwitch>
);

export default InputSwitch;
